import {
    Container,
    Stack,
    Flex,
    Box,
    Heading,
    Text,
    Button,
    Image,
    Link,
    HStack,
    Center,
    useColorMode
  } from '@chakra-ui/react';
  import Typewriter from "typewriter-effect";
  import Profile_pic from "../assets/avinash_profile-pic.png"
  import Resume from "../assets/fw19_0359-Avinash-Kumar-Resume.pdf";
   import * as Scroll from 'react-scroll';
  
  export default function About() {
    const { colorMode } = useColorMode();
    return (
      <Container maxW={'7xl'} id="about" >
        <Stack id="navbar"
          align={'center'}
          spacing={{ base: 8, md: 10 }}
          py={{ base: 20, md: 28 }}
          direction={{ base: 'column', md: 'row' }}>
          <Stack flex={1} spacing={{ base: 5, md: 10 }}>
            <Heading
              lineHeight={1.1}
              fontWeight={600}
              fontSize={{ base: '3xl', sm: '4xl', lg: '6xl' }}>
              <Text color={colorMode === 'light' ? "teal":"white" }>
                Avinash Kumar
              </Text>
              <Text fontSize={'4xl'} as={'span'} color={colorMode === 'light' ? "purple":"purple.400" }>
              <Typewriter
                  options={{
                    strings: [
                      "Aspiring Developer",
                      "Full Stack Web Developer"
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 50
                  }}
               /> 
              </Text>
            </Heading>
            <Text color={colorMode === 'light' ? "gray.":"white" }>
             A Full Stack Frontend Web Developer, Trained by Masai School, Bangaluru. 1500+ hours coding experience.
             Able to make a beutiful website. Creative mind and positive attitude. Fast learning is my strenght.
            </Text>
            <Center>
            <HStack
              spacing={{ base: 4, sm: 6 }}
              >
              <Scroll.Link to="contact" spy={true} smooth={true}>
              <Button
                rounded={'full'}
                size={'lg'}
                fontWeight={'normal'}
                px={6}
                colorScheme={'red'}
                bg={'teal'}
                color={'white'}
                _hover={{ bg: 'teal.300' }}
                >
                Hire
              </Button>
              </Scroll.Link>
              <Link href={Resume} download style={{textDecoration: "none"}}>
              <Button
                rounded={'full'}
                size={'lg'}
                fontWeight={'normal'}
                px={6}
                color={'white'}
                colorScheme={'red'}
                bg={'teal'}
                _hover={{ bg: 'teal.300'}}
                onClick={()=>{
                  window.open("https://drive.google.com/file/d/1ct5jDBV0670lZqrFfba74KCY2C79UZ7B/view?usp=sharing")
                }}
                >
                Download Resume
              </Button>
              </Link>
            </HStack>
            </Center>
          </Stack>
          <Flex
            flex={1}
            justify={'center'}
            align={'center'}
            position={'relative'}
            w={'full'}>
           
            <Box
              rounded={"50%"}
              boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'
              overflow={'hidden'}
              background="white"
              >
             
              <Image
                alt={'Hero Image'}
                fit={'cover'}
                align={'center'}
                objectFit="contain"
                ml={5}
                src={Profile_pic}
              />
            </Box>
          </Flex>
        </Stack>
      </Container>
    );
  }
  
 
  
  